export class MinorServiceClassification {
  minorServiceClassificationId: number;
  name: string;
}
